import React, { useState } from 'react'
 
 
import SalaryHeadList from './SalaryHeadList;';
import SalaryHeadForm from './SalaryHeadForm';

const SalaryHead= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <SalaryHeadForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <SalaryHeadList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default SalaryHead